module.exports = __webpack_public_path__ + "img/chevron_black_left@2x.75c28ae8.png";